import { FormDataType } from '@tw/tw-component-library';
import { CalculationRule } from '../types/form/schema.types';

export const calculateFieldValue = (
  calculation: CalculationRule,
  formData: FormDataType
): number => {
  const { type, sourceFields, customCalculation, roundTo = 2 } = calculation;

  console.log('🔢 Calculation triggered:', { type, sourceFields, formData });

  // Get values from source fields
  const values = sourceFields.map((fieldName) => {
    if (fieldName === 'gridData') {
      const gridData = formData[fieldName];

      console.log('📊 Processing gridData:', gridData);

      // Handle different gridData structures
      if (gridData && typeof gridData === 'object') {
        // If gridData has a data property (table structure)
        if ('data' in gridData && Array.isArray(gridData.data)) {
          const amounts = gridData.data.map(
            (row: any) => parseFloat(row.amount) || 0
          );
          console.log('📊 Extracted amounts from gridData.data:', amounts);
          return amounts;
        }
        // If gridData is directly an array
        else if (Array.isArray(gridData)) {
          const amounts = gridData.map(
            (row: any) => parseFloat(row.amount) || 0
          );
          console.log('📊 Extracted amounts from gridData array:', amounts);
          return amounts;
        }
        // If gridData is an object with payment_details property
        else if (
          'payment_details' in gridData &&
          Array.isArray(gridData.payment_details)
        ) {
          const amounts = gridData.payment_details.map(
            (row: any) => parseFloat(row.amount) || 0
          );
          console.log(
            '📊 Extracted amounts from gridData.payment_details:',
            amounts
          );
          return amounts;
        }
      }

      // Fallback: try to extract amounts from any array-like structure
      if (Array.isArray(gridData)) {
        const amounts = gridData.map((row: any) => parseFloat(row.amount) || 0);
        console.log('📊 Extracted amounts from fallback:', amounts);
        return amounts;
      }

      console.log(
        '📊 No valid gridData structure found, returning empty array'
      );
      return [];
    }
    return formData[fieldName];
  });

  console.log('📊 Final values for calculation:', values);

  let result: number;

  switch (type) {
    case 'sum':
      result = values
        .flat()
        .reduce((sum: number, val: number) => sum + (parseFloat(val) || 0), 0);
      break;

    case 'multiply':
      result = values.reduce(
        (product: number, val: number) => product * (parseFloat(val) || 1),
        1
      );
      break;

    case 'subtract':
      result = values.reduce((diff: number, val: number, index: number) =>
        index === 0 ? parseFloat(val) || 0 : diff - (parseFloat(val) || 0)
      );
      break;

    case 'divide':
      result = values.reduce((quotient: number, val: number, index: number) => {
        const numVal = parseFloat(val) || 0;
        return index === 0
          ? numVal
          : numVal === 0
          ? quotient
          : quotient / numVal;
      });
      break;

    case 'custom':
      if (customCalculation) {
        result = customCalculation(values.flat(), formData);
      } else {
        result = 0;
      }
      break;

    default:
      result = 0;
  }

  // Round the result to specified decimal places
  const finalResult = Number(result.toFixed(roundTo));
  console.log('🔢 Calculation result:', finalResult);
  return finalResult;
};
